import { areaSettings } from 'routes/Explore/components/Settings/components/ChartSettingsDrawer/helpers/settingsByViz/area';
import { getMappedColor } from '../helpers/getColor';
import {
    CartesianChartOption,
    CartesianChartType,
} from './CartesianChartOption';
import { EChartsSerie } from './types';
import { ChartSettingsT, OrderedColumnsT } from 'business/definitions';
import { getValidSettings } from './helpers';

export class AreaChartOption extends CartesianChartOption {
    constructor(
        orderedColumns: OrderedColumnsT,
        settings: ChartSettingsT,
        data: ResponseDataT[],
        width: number,
        height: number,
        dataZoomInterval: [number, number] | undefined,
        isPdfModeActivated: boolean,
        isPngModeActivated: boolean,
        isChartViewedOnDashboard: boolean,
    ) {
        // Delete unhandled settings:
        const properSettings = getValidSettings(settings, areaSettings);
        super(
            orderedColumns,
            properSettings,
            data,
            width,
            height,
            dataZoomInterval,
            isPdfModeActivated,
            isPngModeActivated,
            isChartViewedOnDashboard,
        );
    }

    protected getChartType(): CartesianChartType {
        return 'line';
    }

    /** For area chart, we want to treat the X axis as if it is always
     * a category type, otherwise we have some bug with EChart.
     * See EChart #1214.
     */
    protected override getXAxisType(): 'category' | 'time' | 'value' {
        return 'category';
    }

    protected override getSeries(): EChartsSerie[] {
        // @ts-expect-error [typing] We don't conform perfectly to echart serie type.
        return super.getSeries().map((serie, serieIndex) => ({
            ...serie,
            // This is needed to properly show it has a area.
            areaStyle: {},
            stack: 'areaStack',
            smooth: 0.05,
            emphasis: { focus: 'series' },
            blur: { lineStyle: { opacity: 0.25 } },
            symbolSize: this.settings.areLabelsShown ? 0 : 4,
            showSymbol: !!this.settings.areLabelsShown,
            itemStyle: {
                color: getMappedColor(
                    serie.name,
                    serieIndex,
                    this.getCustomColor(serie.name),
                    this.getColor(),
                ),
            },
            label: {
                ...serie.label,
                color: 'white',
                textBorderColor: getMappedColor(
                    serie.name,
                    serieIndex,
                    this.getCustomColor(serie.name),
                    this.getColor(),
                ),
                textBorderWidth: 4,
                position: 'inside',
                align: 'center',
            },
        }));
    }
}
